// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.VerifyOtp-module__verifyOtpContainer___tnp_7 {
  background: #fff;
  border-radius: 10px;
  padding: 20px;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
  position: relative;
  text-align: center;
}

.VerifyOtp-module__verifyOtpHeader___Ryppp {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.VerifyOtp-module__verifyOtpHeader___Ryppp h2 {
  font-size: 20px;
  margin: 0;
  color: #111;
}

.VerifyOtp-module__closeBtn___GPiua {
  background: none;
  border: none;
  font-size: 22px;
  cursor: pointer;
  color: #333;
}

.VerifyOtp-module__otpInfo___seZ46 {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 6px;
  margin-top: 10px;
}

.VerifyOtp-module__otpInfo___seZ46 p {
  font-size: 14px;
  color: #444;
  margin: 0;
}

.VerifyOtp-module__phoneNumber___a0kCY {
  font-weight: bold;
}

.VerifyOtp-module__editLink___tveFu {
  font-size: 13px;
  color: #00a86b;
  cursor: pointer;
}

.VerifyOtp-module__otpExpiry___yTpGd {
  font-size: 13px;
  color: #2e64e5;
  margin: 8px 0 18px;
}

.VerifyOtp-module__otpInputs___DaeWd {
  display: flex;
  justify-content: center;
  gap: 10px;
  margin-bottom: 20px;
}

.VerifyOtp-module__otpInputs___DaeWd input {
  width: 45px;
  height: 45px;
  font-size: 18px;
  text-align: center;
  border: 1px solid #b0b7c3;
  border-radius: 6px;
  outline: none;
  transition: border-color 0.3s ease;
}

.VerifyOtp-module__otpInputs___DaeWd input:focus {
  border-color: #2e64e5;
}

.VerifyOtp-module__verifyOtpBtn___v8yFH {
  width: 100%;
  background: #1e2e3e;
  color: white;
  padding: 12px;
  font-size: 14px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  margin-bottom: 16px;
  transition: background 0.3s ease;
}

.VerifyOtp-module__verifyOtpBtn___v8yFH:hover {
  background: #162431;
}

.VerifyOtp-module__resendOtp___MGPop {
  font-size: 13px;
  color: #a9f0dc;
  margin-top: 4px;
}

.VerifyOtp-module__error___qt6PK{
  margin-bottom: 5px;
  color:red;
  font-size: 12px;
}`, "",{"version":3,"sources":["webpack://./src/modals/verifyotp/VerifyOtp.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,2CAA2C;EAC3C,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,SAAS;AACX;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,kCAAkC;AACpC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,eAAe;AACjB","sourcesContent":[".verifyOtpContainer {\n  background: #fff;\n  border-radius: 10px;\n  padding: 20px;\n  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);\n  position: relative;\n  text-align: center;\n}\n\n.verifyOtpHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.verifyOtpHeader h2 {\n  font-size: 20px;\n  margin: 0;\n  color: #111;\n}\n\n.closeBtn {\n  background: none;\n  border: none;\n  font-size: 22px;\n  cursor: pointer;\n  color: #333;\n}\n\n.otpInfo {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 6px;\n  margin-top: 10px;\n}\n\n.otpInfo p {\n  font-size: 14px;\n  color: #444;\n  margin: 0;\n}\n\n.phoneNumber {\n  font-weight: bold;\n}\n\n.editLink {\n  font-size: 13px;\n  color: #00a86b;\n  cursor: pointer;\n}\n\n.otpExpiry {\n  font-size: 13px;\n  color: #2e64e5;\n  margin: 8px 0 18px;\n}\n\n.otpInputs {\n  display: flex;\n  justify-content: center;\n  gap: 10px;\n  margin-bottom: 20px;\n}\n\n.otpInputs input {\n  width: 45px;\n  height: 45px;\n  font-size: 18px;\n  text-align: center;\n  border: 1px solid #b0b7c3;\n  border-radius: 6px;\n  outline: none;\n  transition: border-color 0.3s ease;\n}\n\n.otpInputs input:focus {\n  border-color: #2e64e5;\n}\n\n.verifyOtpBtn {\n  width: 100%;\n  background: #1e2e3e;\n  color: white;\n  padding: 12px;\n  font-size: 14px;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  margin-bottom: 16px;\n  transition: background 0.3s ease;\n}\n\n.verifyOtpBtn:hover {\n  background: #162431;\n}\n\n.resendOtp {\n  font-size: 13px;\n  color: #a9f0dc;\n  margin-top: 4px;\n}\n\n.error{\n  margin-bottom: 5px;\n  color:red;\n  font-size: 12px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"verifyOtpContainer": `VerifyOtp-module__verifyOtpContainer___tnp_7`,
	"verifyOtpHeader": `VerifyOtp-module__verifyOtpHeader___Ryppp`,
	"closeBtn": `VerifyOtp-module__closeBtn___GPiua`,
	"otpInfo": `VerifyOtp-module__otpInfo___seZ46`,
	"phoneNumber": `VerifyOtp-module__phoneNumber___a0kCY`,
	"editLink": `VerifyOtp-module__editLink___tveFu`,
	"otpExpiry": `VerifyOtp-module__otpExpiry___yTpGd`,
	"otpInputs": `VerifyOtp-module__otpInputs___DaeWd`,
	"verifyOtpBtn": `VerifyOtp-module__verifyOtpBtn___v8yFH`,
	"resendOtp": `VerifyOtp-module__resendOtp___MGPop`,
	"error": `VerifyOtp-module__error___qt6PK`
};
export default ___CSS_LOADER_EXPORT___;
